import * as React from "react";
import styled, { useTheme } from "styled-components";
import { NoSearchResult } from "components/common";
import GenericPlot from "views/components/visualizations/GenericPlot";
import useUserDateTime from "hooks/useUserDateTime";
import { adjustFormat, toUTCFromTz } from "util/DateTime";
import useDisplayName from "ai-management/token-usage/hooks/useDisplayName";
import UsageSection from "ai-management/token-usage/UsageSection";
import { GROUPINGS } from "ai-management/token-usage/breakdown";
import { toTimeSeries } from "ai-management/token-usage/charts";
const ChartContainer = styled.div`
  height: 280px;
`;
const TokensOverTimeChart = ({ usage, grouping, colors, onZoom }) => {
  const theme = useTheme();
  const { formatTime, userTimezone } = useUserDateTime();
  const displayName = useDisplayName();
  const { label } = GROUPINGS[grouping];
  const { buckets, series } = toTimeSeries(usage.rows, grouping);
  const bucketTimes = buckets.map((bucket) => formatTime(bucket, "internal"));
  const toUTC = (dateTime) => adjustFormat(toUTCFromTz(dateTime, userTimezone), "internal");
  const seriesName = ({ group }) => displayName(group);
  const chartData = series.map((entry) => ({
    type: "bar",
    name: seriesName(entry),
    x: bucketTimes,
    y: entry.values,
    marker: {
      color: colors.get(entry.key),
      // A thin gap in the surface color separates the stacked segments.
      line: { color: theme.colors.global.contentBackground, width: 1 }
    }
  }));
  return /* @__PURE__ */ React.createElement(UsageSection, { title: "Tokens over time", detail: `by ${label.toLowerCase()}` }, series.length === 0 ? /* @__PURE__ */ React.createElement(NoSearchResult, null, "No token usage in the selected time range.") : /* @__PURE__ */ React.createElement(ChartContainer, null, /* @__PURE__ */ React.createElement(
    GenericPlot,
    {
      chartData,
      onZoom: (from, to) => onZoom(toUTC(from), toUTC(to)),
      layout: {
        barmode: "stack",
        bargap: 0.35,
        dragmode: "zoom",
        hovermode: "x",
        xaxis: { type: "date" },
        yaxis: { rangemode: "tozero", fixedrange: true },
        margin: { t: 10, r: 10, b: 40, l: 50 }
      }
    }
  )));
};
export default TokensOverTimeChart;
